import tmhRequest from '@/config/tmhRequest'

export default {
 
    searchCompany: function (data) {
        return tmhRequest({
            url: '/hr/tmh/company/searchcompany',
            method: 'post',
            params: data,
        })
    },

    searchListCompany: function (data) {
        return tmhRequest({
            url: '/hr/tmh/company/searchlistcompany',
            method: 'post',
            params: data,
        })
    },
 
    searchCompanyCount: function (data) {
        return tmhRequest({
            url: '/hr/tmh/company/searchcompanycount',
            method: 'post',
            params: data,
        })
    },
    searchCompanyByPage: function (data) {
        return tmhRequest({
            url: '/hr/tmh/company/searchcompanybypage',
            method: 'post',
            params: data,
        })
    },
    addCompany: function (data) {
        return tmhRequest({
            url: '/hr/tmh/company/addcompany',
            method: 'post',
            params: data,
        })
    },
    editCompany: function (data) {
        return tmhRequest({
            url: '/hr/tmh/company/editcompany',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/hr/company.js